import { get } from '@alltrails/shared/api';

const key = '3p0t5s6b5g4g0e8k3c1j3w7y5c3m4t8i';

async function refreshUser(id: string | number) {
  return get(`/api/alltrails/users/${id}/refresh?key=${key}`);
}

export default refreshUser;
